module.exports = __webpack_public_path__ + "img/product-list_m3.11de4922.png";